(function ($) {
    let methods = {
        init: function (options) {
            return this.each(function () {
                let id = $(this).attr('id');
                $(document).on('keyup', '#' + id, function () {
                    let input = $(this).val();
                    $(document).find('#' + id + '-wrap').find('.requirements').each(function () {
                        let marker = $(this);
                        let type = $(this).attr('data-type');
                        let value = $(this).attr('data-value');

                        switch (type) {
                            case "min-length":
                                if (input.length < parseInt(value)) {
                                    markerError(marker);
                                } else {
                                    markerApplied(marker);
                                }
                                break;
                            case "regex":
                                value = new RegExp(value);
                                if (value.test(input)) {
                                    markerApplied(marker);
                                } else {
                                    markerError(marker);
                                }
                                break;
                        }
                    });
                });
            });
        },
    };

    let markerError = function (marker) {
        $(marker).find('span').removeClass('applied').addClass('error');
    };

    let markerApplied = function (marker) {
        $(marker).find('span').removeClass('error').addClass('applied');
    };

    jQuery.fn.requirementMarkers = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method named ' + method + ' does not exist for jQuery.customAlert');
        }
    };
})(jQuery);